const partTypeStrings = {
    FRONT_WIPER: "FRONT WIPER",
    REAR_WIPER: "REAR WIPER",
    RAIN_REPEL: "RAIN REPEL",
    ADAS_RECALIBRATION: "ADAS RECALIBRATION",
    RECALIBRATION: "RECALIBRATION",
    REPLACE_FEE: "REPLACE FEE",
    RECYCLE_FEE: "RECYCLE FEE",
    MOBILE_FEE: "MOBILE FEE",
    REPAIR_FEE: "REPAIR FEE",
    EARLY_BIRD: "EARLY BIRD",
    QUOTE_PAGE_DISCOUNT: "QUOTE PAGE DISCOUNT",
    DONATION: "DONATION",
    WINDSHIELD: "WINDSHIELD",
};

export { partTypeStrings };
